export enum PROJECT_FACADE_SECTION_ALIAS {
  COMMON = 'common',
  PRODUCT = 'product',
  GLAZING = 'glazing',
  PANE_GLAZING = 'pane-glazing',
  PANE = 'pane',
  LEGEND = 'legend',
}
